    (function() {

        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const html = document.documentElement;

        if ( /windows phone/i.test(ua) ) {
            html.classList.add( 'windows' );
        } else if ( /win/i.test(ua) ) {
            html.classList.add( 'windows' );
        } else if ( /android/i.test(ua) ) {
            html.classList.add( 'android', 'mobile' );
        } else if ( /iPad|iPhone|iPod/.test(ua) && !window.MSStream ) {
            html.classList.add( 'ios', 'mobile' );
        } else if ( /Macintosh|MacIntel|MacPPC|Mac68K/.test(ua) ) {
            html.classList.add( 'mac' );
        }

        if ( /chrome|crios/i.test(ua) && !/edge|edg|opr|opera/i.test(ua) ) {
            html.classList.add( 'chrome' );
        } else if ( /firefox|fxios/i.test(ua) ) {
            html.classList.add( 'firefox' );
        } else if ( /safari/i.test(ua) && !/chrome|crios|android/i.test(ua) ) {
            html.classList.add( 'safari' );
        } else if ( /edg/i.test(ua) ) {
            html.classList.add( 'edge' );
        } else if ( /opr|opera/i.test(ua) ) {
            html.classList.add( 'opera' );
        }

    })();

    document.addEventListener( 'click', function(e) {
        var localisation = document.querySelector( '.localisation' );
        if ( !localisation ) return;
        if ( e.target.closest( '[data-action="Localisation"]' ) ) {
            localisation.classList.add( 'delay' );
            setTimeout( function () {
                localisation.classList.add( 'active' );
            }, 100 );
        }
        if ( e.target.closest( '.localisation .close, .localisation .overlay' ) ) {
            setTimeout( function () {
                localisation.classList.remove( 'delay' );
            }, 750 );
            localisation.classList.remove( 'active' );
        }
    });

    document.addEventListener( 'DOMContentLoaded', function () {
        function addClasses() {
            const elements = document.querySelectorAll( '.nosto_element, .tolstoy-carousel' );
            if ( ! elements.length ) {
                return false;
            }
            elements.forEach( function ( el ) {
                const section = el.closest( '.shopify-section' );
                if ( ! section ) {
                    return;
                }
                if ( el.classList.contains( 'nosto_element' ) ) {
                    section.classList.add( 'nosto' );
                }
                if ( el.classList.contains( 'tolstoy-carousel' ) ) {
                    section.classList.add( 'tolstoy' );
                }
            });
            return true;
        }
        if ( addClasses() ) {
            return;
        }
        const observer = new MutationObserver( function () {
            if ( addClasses() ) {
                observer.disconnect();
            }
        });
        observer.observe( document.body,{
            childList: true,
            subtree: true
        });
    });

    window.addEventListener( 'load', function ( ) {
        const reviewsSlider = document.querySelector( '.reviews .slider' );
        if ( ! reviewsSlider || typeof Swiper === 'undefined' ) {
            return;
        }
        new Swiper( reviewsSlider, {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            loop: reviewsSlider.querySelectorAll( '.slide' ).length > 4,
            speed: 750,
            autoplay: {
                delay: 7500,
                disableOnInteraction: false,
                waitForTransition: true,
                pauseOnMouseEnter: true
            },
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.reviews .navigation .buttons .button.one',
                nextEl: '.reviews .navigation .buttons .button.two'
            },
            pagination: {
                bulletClass: 'icon',
                bulletActiveClass: 'active',
                el: '.reviews .pagination .icons',
                dynamicBullets: true
            },
            breakpoints: {
                0: {
                    spaceBetween: 12,
                    slidesPerView: 1,
                    speed: 625
                },
                600: {
                    spaceBetween: 12,
                    slidesPerView: 2,
                    speed: 625
                },
                900: {
                    spaceBetween: 15,
                    slidesPerView: 3,
                    speed: 750
                },
                1375: {
                    spaceBetween: 16,
                    slidesPerView: 4,
                    speed: 750
                }
            }
        });
    });

    const header = document.querySelector( '.js-announcement-bar' );
    const openElements = document.querySelectorAll( '[data-header-menu], .js-nav-mobile-menu' );
    const sync = () => {
        if ( ! header ) return;
        const isOpen = [ ...openElements ].some( ( element ) => element.hasAttribute( 'open' ) );
        header.classList.toggle( 'active', isOpen );
    };
    const observer = new MutationObserver( sync );
    openElements.forEach( ( element ) => {
        observer.observe( element, {
            attributes: true,
            attributeFilter: [ 'open' ]
        });
    });
    sync();

    const wrapSize = ( element ) => {
        element.innerHTML = element.innerHTML.replace( /\//g, '<span>/</span>' );
    };
    const unwrapSize = ( element ) => {
        element.querySelectorAll( 'span' ).forEach( ( span ) => {
            if ( span.textContent === '/' ) {
                span.replaceWith( '/' );
            }
        });
    };
    document.addEventListener( 'DOMContentLoaded', () => {
        document.querySelectorAll( '.product [data-product] [data-variant-sizes]' ).forEach( ( element ) => {
            wrapSize( element );
        });
        document.querySelectorAll( '.product [data-product] [data-swatches-container] [data-variant-input-holder] input' ).forEach( ( input ) => {
            input.addEventListener( 'click', ( event ) => {
                const product = event.target.closest( '[data-product]' );
                if ( ! product ) return;
                const sizes = product.querySelector( '[data-variant-sizes]' );
                if ( ! sizes ) return;
                unwrapSize( sizes );
                requestAnimationFrame( () => {
                    wrapSize( sizes );
                });
            });
        });
    });